import { useConditionFieldNameFieldPath } from '../fieldPaths';
import { useController } from '../../../contexts';
import { useTranslation } from '../../useTranslation';

export const useConditionFieldNameController = () => {
  const { t } = useTranslation();
  const fieldPath = useConditionFieldNameFieldPath();
  return useController({
    name: fieldPath,
    rules: { required: t('conditionalContent.conditions.unfulfilledInputs') },
  });
};
